import 'react';
var REACT_ELEMENT_TYPE;
function _createRawReactElement(e, r, E, l) {
  REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol["for"] && Symbol["for"]("react.element") || 60103);
  var o = e && e.defaultProps,
    n = arguments.length - 3;
  if (r || 0 === n || (r = {
    children: void 0
  }), 1 === n) r.children = l;else if (n > 1) {
    for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];
    r.children = t;
  }
  if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});
  return {
    $$typeof: REACT_ELEMENT_TYPE,
    type: e,
    key: void 0 === E ? null : "" + E,
    ref: null,
    props: r,
    _owner: null
  };
}
var _svg$9;
var ArrowRight = function ArrowRight() {
  return _svg$9 || (_svg$9 = /*#__PURE__*/_createRawReactElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    transform: "scale(-1, 1)"
  }, void 0, /*#__PURE__*/_createRawReactElement("path", {
    d: "M3.26053 13.2139L8.79868 19.6422C9.15531 20.0809 9.86015 20.12 10.2735 19.7382C10.6868 19.3563 10.7287 18.6279 10.3455 18.2139L6.34325 13.5711L19.9615 13.5711C20.5349 13.5711 21 13.0913 21 12.4997C21 11.908 20.5352 11.4282 19.9615 11.4282L6.34325 11.4282L10.3455 6.78548C10.7287 6.37145 10.677 5.64426 10.2634 5.26239C9.84998 4.8805 9.15528 4.91837 8.79868 5.35706L3.26053 11.7854C2.89882 12.305 2.9278 12.7716 3.26053 13.2138V13.2139Z",
    fill: "#737373"
  })));
};
var ArrowRight$1 = ArrowRight;
var _svg$8;
var ArrowLeft = function ArrowLeft() {
  return _svg$8 || (_svg$8 = /*#__PURE__*/_createRawReactElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, void 0, /*#__PURE__*/_createRawReactElement("path", {
    d: "M3.26053 13.2139L8.79868 19.6422C9.15531 20.0809 9.86015 20.12 10.2735 19.7382C10.6868 19.3563 10.7287 18.6279 10.3455 18.2139L6.34325 13.5711L19.9615 13.5711C20.5349 13.5711 21 13.0913 21 12.4997C21 11.908 20.5352 11.4282 19.9615 11.4282L6.34325 11.4282L10.3455 6.78548C10.7287 6.37145 10.677 5.64426 10.2634 5.26239C9.84998 4.8805 9.15528 4.91837 8.79868 5.35706L3.26053 11.7854C2.89882 12.305 2.9278 12.7716 3.26053 13.2138V13.2139Z",
    fill: "#737373"
  }), /*#__PURE__*/_createRawReactElement("path", {
    d: "M3.26053 13.2139L8.79868 19.6422C9.15531 20.0809 9.86015 20.12 10.2735 19.7382C10.6868 19.3563 10.7287 18.6279 10.3455 18.2139L6.34325 13.5711L19.9615 13.5711C20.5349 13.5711 21 13.0913 21 12.4997C21 11.908 20.5352 11.4282 19.9615 11.4282L6.34325 11.4282L10.3455 6.78548C10.7287 6.37145 10.677 5.64426 10.2634 5.26239C9.84998 4.8805 9.15528 4.91837 8.79868 5.35706L3.26053 11.7854C2.89882 12.305 2.9278 12.7716 3.26053 13.2138V13.2139Z",
    fill: "#737373"
  })));
};
var ArrowLeft$1 = ArrowLeft;
var _svg$7;
var ChevronRight = function ChevronRight() {
  return _svg$7 || (_svg$7 = /*#__PURE__*/_createRawReactElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, void 0, /*#__PURE__*/_createRawReactElement("path", {
    d: "M16 11.4999L15.6598 11.8638L8.9616 19L8 18.2723L14.358 11.5L8 4.72767L8.9616 4L15.6598 11.1362L16 11.5001L16 11.4999Z",
    fill: "black",
    "fill-opacity": "0.55"
  })));
};
var ChevronRight$1 = ChevronRight;
var _svg$6;
var ChevronLeft = function ChevronLeft() {
  return _svg$6 || (_svg$6 = /*#__PURE__*/_createRawReactElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, void 0, /*#__PURE__*/_createRawReactElement("path", {
    d: "M8 11.4999L8.3402 11.8638L15.0384 19L16 18.2723L9.64197 11.5L16 4.72767L15.0384 4L8.3402 11.1362L8 11.5001L8 11.4999Z",
    fill: "black",
    "fill-opacity": "0.55"
  })));
};
var ChevronLeft$1 = ChevronLeft;
var _svg$5;
var ChevronBoldRight = function ChevronBoldRight() {
  return _svg$5 || (_svg$5 = /*#__PURE__*/_createRawReactElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, void 0, /*#__PURE__*/_createRawReactElement("path", {
    d: "M9.9346 4.9325L8.874 5.99316L14.8777 11.9969L8.8677 18.0069L9.9284 19.0676L17 11.9969L9.9346 4.9325Z",
    fill: "black",
    fillOpacity: "0.55"
  })));
};
var ChevronBoldRight$1 = ChevronBoldRight;
var _svg$4;
var ChevronBoldLeft = function ChevronBoldLeft() {
  return _svg$4 || (_svg$4 = /*#__PURE__*/_createRawReactElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, void 0, /*#__PURE__*/_createRawReactElement("path", {
    d: "M14.0654 4.9325L15.126 5.99316L9.1223 11.9969L15.1323 18.0069L14.0716 19.0676L7.00098 11.9969L14.0654 4.9325Z",
    fill: "black",
    "fill-opacity": "0.55"
  })));
};
var ChevronBoldLeft$1 = ChevronBoldLeft;
var _svg$3;
var PlayMedium = function PlayMedium() {
  return _svg$3 || (_svg$3 = /*#__PURE__*/_createRawReactElement("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, void 0, /*#__PURE__*/_createRawReactElement("path", {
    d: "M17 10L5 17L5 3L17 10Z",
    fill: "black"
  })));
};
var PlayMedium$1 = PlayMedium;
var _svg$2;
var PlaySmall = function PlaySmall() {
  return _svg$2 || (_svg$2 = /*#__PURE__*/_createRawReactElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, void 0, /*#__PURE__*/_createRawReactElement("path", {
    d: "M13 8L5 13L5 3L13 8Z",
    fill: "black"
  })));
};
var PlaySmall$1 = PlaySmall;
var PLAY_ICON_BY_SIZE = {
  small: PlaySmall$1,
  medium: PlayMedium$1
};
var Play = function Play(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? "medium" : _ref$size;
  var Component = PLAY_ICON_BY_SIZE[size] || PlayMedium$1;
  return /*#__PURE__*/_createRawReactElement(Component, {});
};
var Play$1 = Play;
var _path, _path2;
var PaintBrush = function PaintBrush(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'none' : _ref$color;
  return /*#__PURE__*/_createRawReactElement("svg", {
    width: "24",
    height: "22",
    viewBox: "0 0 24 22",
    fill: color,
    xmlns: "http://www.w3.org/2000/svg"
  }, void 0, _path || (_path = /*#__PURE__*/_createRawReactElement("path", {
    d: "M18.3338 14.1994L17.5042 13.3703L22 8.87455L14.1268 1.00098L9.63109 5.49674L8.80198 4.66763L5.33293 8.13668L7.30269 13.0058L2.4689 17.3935C1.8437 18.0187 1.8437 19.0357 2.4689 19.6614L3.34005 20.5325C3.96482 21.1573 4.98228 21.1573 5.62177 20.5178L9.99435 15.6987L14.8647 17.6689L18.3338 14.1994ZM14.1268 2.1904L15.2376 3.30078L13.6526 4.88542L14.2471 5.47992L15.8322 3.89528L16.5271 4.59027L14.9421 6.17491L15.5366 6.76941L17.1216 5.18477L17.8162 5.87934L15.0817 8.61388L15.6762 9.20838L18.4107 6.47384L19.1057 7.16883L17.5206 8.75346L18.1156 9.34797L19.7002 7.76333L20.811 8.87413L16.9102 12.7754L10.2256 6.09124L14.1268 2.1904ZM14.6642 16.6804L9.76689 14.6993L5.01298 19.938C4.71573 20.2353 4.23222 20.2353 3.93497 19.938L3.06382 19.0669C2.76657 18.7696 2.76657 18.2861 3.0491 18.0027L8.3025 13.2345L6.3218 8.33807L7.40864 7.25165L8.00314 6.65715L8.80198 5.85706L9.03616 6.09166L16.9102 13.9657L17.1452 14.2003L14.6642 16.6804Z",
    fill: "black",
    "fill-opacity": "0.55"
  })), _path2 || (_path2 = /*#__PURE__*/_createRawReactElement("path", {
    d: "M18.3868 14.2525L18.4398 14.1994L18.3868 14.1464L17.6103 13.3703L22.053 8.92758L22.1061 8.87455L22.053 8.82152L14.1799 0.947945L14.1268 0.894909L14.0738 0.947944L9.63109 5.39067L8.85501 4.6146L8.80198 4.56157L8.74895 4.6146L5.2799 8.08365L5.24478 8.11877L5.2634 8.16481L7.21354 12.9854L2.41849 17.338L2.41843 17.3379L2.41586 17.3405C1.76137 17.995 1.76139 19.0595 2.41584 19.7144L2.41586 19.7144L3.28701 20.5855C3.94152 21.24 5.00647 21.2392 5.6748 20.5708L5.67487 20.5709L5.67732 20.5682L10.0147 15.7879L14.8366 17.7384L14.8826 17.757L14.9178 17.7219L18.3868 14.2525ZM14.3001 5.53296L15.8321 4.00134L16.4211 4.59026L14.8891 6.12187L14.836 6.1749L14.889 6.22794L15.4835 6.82244L15.5366 6.87547L15.5896 6.82245L17.1216 5.29083L17.7101 5.87934L15.0286 8.56085L14.9756 8.61388L15.0286 8.66691L15.6231 9.26141L15.6762 9.31445L15.7292 9.26141L18.4107 6.57991L18.9996 7.16882L17.4676 8.70042L17.4145 8.75348L17.4676 8.80652L18.0625 9.40102L18.1156 9.45401L18.1686 9.401L19.7002 7.8694L20.7049 8.87414L16.9102 12.6693L10.3317 6.09124L14.1269 2.29645L15.1316 3.30079L13.5996 4.83238L13.5465 4.88541L13.5996 4.93845L14.1941 5.53295L14.2471 5.58598L14.3001 5.53296ZM8.05622 6.71014L8.80197 5.96321L8.98308 6.14465L8.98313 6.14469L16.8571 14.0187L16.8572 14.0187L17.0391 14.2003L14.6463 16.5923L9.79501 14.6298L9.74651 14.6102L9.71135 14.6489L4.95869 19.8862C4.69062 20.1529 4.25554 20.1525 3.988 19.885L3.11685 19.0138C2.84844 18.7454 2.84976 18.3104 3.10092 18.057L8.3529 13.29L8.39164 13.2549L8.37202 13.2064L6.40996 8.356L7.46166 7.3047L7.46167 7.30469L8.05618 6.71018L8.05622 6.71014Z",
    stroke: "black",
    "stroke-opacity": "0.55",
    "stroke-width": "0.15"
  })));
};
var PaintBrush$1 = PaintBrush;
var _svg$1;
var CustomCategoriesSmall = function CustomCategoriesSmall() {
  return _svg$1 || (_svg$1 = /*#__PURE__*/_createRawReactElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, void 0, /*#__PURE__*/_createRawReactElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 4.4H4.4V2H2V4.4ZM5.59971 3.8001H13.9997V2.6001H5.59971V3.8001ZM13.9996 13.4002H5.59961V12.2002H13.9996V13.4002ZM2 14.0001H4.4V11.6001H2V14.0001ZM13.9996 8.59893H5.59961V7.39893H13.9996V8.59893ZM2 9.19883H4.4V6.79883H2V9.19883Z",
    fill: "black",
    "fill-opacity": "0.9"
  })));
};
var CustomCategoriesSmall$1 = CustomCategoriesSmall;
var _svg;
var CustomCategoriesMedium = function CustomCategoriesMedium() {
  return _svg || (_svg = /*#__PURE__*/_createRawReactElement("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, void 0, /*#__PURE__*/_createRawReactElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.79961 2.8001H5.19961V5.2001H2.79961V2.8001ZM1.59961 6.4001V1.6001H6.39961V6.4001H1.59961ZM2.79961 14.8001H5.19961V17.2001H2.79961V14.8001ZM1.59961 18.4001V13.6001H6.39961V18.4001H1.59961ZM5.19961 8.8001H2.79961V11.2001H5.19961V8.8001ZM1.59961 7.6001V12.4001H6.39961V7.6001H1.59961ZM8.80005 4.60002H17.2V3.40002H8.80005V4.60002ZM17.2 10.6H8.80005V9.40002H17.2V10.6ZM8.80005 16.6H17.2V15.4H8.80005V16.6Z",
    fill: "black"
  })));
};
var CustomCategoriesMedium$1 = CustomCategoriesMedium;
var CUSTOM_CATEGORIES_ICON_BY_SIZE = {
  small: CustomCategoriesSmall$1,
  medium: CustomCategoriesMedium$1
};
var CustomCategories = function CustomCategories(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size;
  var Component = CUSTOM_CATEGORIES_ICON_BY_SIZE[size] || CustomCategoriesMedium$1;
  return /*#__PURE__*/_createRawReactElement(Component, {});
};
var CustomCategories$1 = CustomCategories;
export { ArrowLeft$1 as ArrowLeft, ArrowRight$1 as ArrowRight, ChevronBoldLeft$1 as ChevronBoldLeft, ChevronBoldRight$1 as ChevronBoldRight, ChevronLeft$1 as ChevronLeft, ChevronRight$1 as ChevronRight, CustomCategories$1 as CustomCategories, PaintBrush$1 as PaintBrush, Play$1 as Play };
